import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import type { Hotkey } from '../hotkeys';
import { Key } from '../hotkeys/KeyStrokes.ts';
import { WinchControlHotkeyNames } from '../hotkeys/types.ts';

export type WinchControlHotkeysDefinitionsResult = ReturnType<
  typeof useWinchControlHotkeysDefinitions
>;

export const useWinchControlHotkeysDefinitions = () => {
  const { t } = useTranslation(['common']);

  return useMemo(
    () =>
      ({
        [WinchControlHotkeyNames.MoveWinchUp]: {
          primary: Key.arrow.ArrowUp,
          optionalPrimary: Key.KeyW,
          description: t('common:shortcuts.winch.moveWinchUp'),
          hotkeyModifier: { modifier: 'Shift' },
        },
        [WinchControlHotkeyNames.MoveWinchDown]: {
          primary: Key.arrow.ArrowDown,
          optionalPrimary: Key.KeyS,
          description: t('common:shortcuts.winch.moveWinchDown'),
          hotkeyModifier: { modifier: 'Shift' },
        },
        [WinchControlHotkeyNames.MoveWinchIn]: {
          primary: Key.arrow.ArrowLeft,
          optionalPrimary: Key.KeyA,
          description: t('common:shortcuts.winch.moveWinchIn'),
          hotkeyModifier: { modifier: 'Shift' },
        },
        [WinchControlHotkeyNames.MoveWinchOut]: {
          primary: Key.arrow.ArrowRight,
          optionalPrimary: Key.KeyD,
          description: t('common:shortcuts.winch.moveWinchOut'),
          hotkeyModifier: { modifier: 'Shift' },
        },
      }) as const satisfies Record<string, Hotkey>,
    [t]
  );
};
